import { useQuery } from '@tanstack/react-query';
import { getIpaTechAssessmentDetail } from '../services/IpaAssessmentService';
import { iimReviewKeys } from './queryKeys';
export function useIpaTechAssessmentDetail(inspectionId, technicianId, enabled) {
    return useQuery({
        queryKey: iimReviewKeys.techAssessmentDetail(inspectionId, technicianId !== null && technicianId !== void 0 ? technicianId : 0),
        queryFn: () => getIpaTechAssessmentDetail(inspectionId, technicianId),
        enabled: enabled && technicianId !== null,
        staleTime: 5 * 60 * 1000,
        cacheTime: 30 * 60 * 1000
    });
}
